;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import svg from "../assets/searchIcon.svg"
import SvgAsset from "./SvgAsset"
import { UI_STYLE_PRIMARY_COLOR } from "../../../../../lib/constants"

function SearchIcon({ color }) {
  return (
    <SvgAsset
      svg={svg}
      viewBox="0 0 31 30"
      width="31px"
      height="30px"
      color={color ? color : UI_STYLE_PRIMARY_COLOR}
    />
  )
}
export default SearchIcon
